import React from 'react'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import { getObjectLabels } from '@paintscout/util/builder'
import type { AcceptedActivityDetails } from '@paintscout/api'
import Highlight from '@paintscout/ui/components/Highlight'
import ActivityTitle from '../ActivityTitle'
import ActivityFooter from '../ActivityFooter'
import ActivityContent from '../ActivityContent'
import type { ActivityTypeComponentProps } from '../Activity'
import { useClientOptions } from '../../../providers/ClientOptionsProvider'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'
import QuoteLabel from '../QuoteLabel'
import ActivityContact from '../ActivityContact'
import ActivityDot from '../ActivityDot'

const useStyles = makeStyles<Theme, ActivityTypeComponentProps<AcceptedActivityDetails>>((theme: Theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  reason: {
    color: theme.palette.text.secondary
  },
  signatureWrapper: {
    '& img': {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  }
}))

export default function QuoteAcceptedActivity(props: ActivityTypeComponentProps<AcceptedActivityDetails>) {
  const { activity, showDocTypeDetails, showContent } = props
  const classes = useStyles(props)
  const { options } = useClientOptions()

  const objectLabels = getObjectLabels({ options })

  const signature = activity?.details?.signature

  const title = activity?.details?.additional ? (
    <ActivityTitle>
      <ActivityDot activity={activity} />
      <>
        <Highlight>{objectLabels.additionalWork.value}</Highlight> was <Highlight>Accepted</Highlight>
        {showDocTypeDetails && <ActivityContact activity={activity} />}
      </>
    </ActivityTitle>
  ) : (
    <ActivityTitle>
      <ActivityDot activity={activity} />
      {showDocTypeDetails ? (
        <>
          <QuoteLabel activity={activity} /> was <Highlight>Accepted</Highlight>
          {showDocTypeDetails && <ActivityContact activity={activity} />}
        </>
      ) : (
        <>
          <Highlight>Accepted</Highlight>
        </>
      )}
    </ActivityTitle>
  )

  return (
    <>
      {title}
      {signature && showContent && (
        <ActivityContent className={classes.content}>
          <div className={classes.signatureWrapper}>
            <img alt={'Estimator Signature'} src={signature} />
          </div>
        </ActivityContent>
      )}
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
